<template>
  <div>
    <el-drawer
      :visible.sync="dataReportVisible"
      title="Al分析报告"
      direction="rtl"
      size="80%"
      :modal-append-to-body="false"
      :before-close="handleClose"
      :lock-scroll="false"
    >
      <div class="data-wrapper flex">
        <div class="data-left">
          <div class="left-title">原材料溯源智能审查助手</div>
          <div
            v-for="(item, index) in reportData"
            :key="index"
            class="left-little-title"
          >
            <div
              style="display: inline-block; cursor: pointer"
              @click="changeLeftShowFlag(item)"
            >
              <eui-icon
                :icon="
                  item.leftShowFlag
                    ? 'eicon-r-l-jiantouzhuangtaixia'
                    : 'eicon-r-l-jiantouzhuangtaishang'
                "
                font-size="16px"
                style="margin-right: 4px"
              ></eui-icon>
            </div>

            {{ item.reviewType }}
            <div v-if="item.leftShowFlag">
              <div
                v-for="(leftData, index) in item.reviewList"
                :key="index"
                @click="toPlace(leftData.uuid)"
              >
                <eui-tooltip-over
                  class="left-content"
                  :tooltip-style="{ width: '139px' }"
                  :content="leftData.reviewName"
                >
                </eui-tooltip-over>
              </div>
            </div>
          </div>
        </div>
        <div class="data-right">
          <div class="tip-wrap">
            <div class="red">提示：</div>
            <div style="padding: 0">
              <p>Al生成内容仅供参考，不作为决策依据，请以实际业务情况为准</p>
            </div>
          </div>
          <div class="version-info">版本信息</div>
          <div class="review-version">
            审查版本：
            <el-select
              v-model="versionID"
              placeholder="请选择"
              style="width: 250px; height: 30px"
              @change="scAiCheckReviewList"
            >
              <el-option
                v-for="item in versionData"
                :key="item.id"
                :label="item.createTime"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div
            v-for="(item, index) in reportData"
            :key="index"
            class="content-wrapper margin-b10"
          >
            <div class="content-title flex-sb">
              <div>{{ item.reviewType }}</div>
              <div style="cursor: pointer" @click="changeShowFlag(index)">
                {{ item.showFlag ? '收起' : '展开' }}
              </div>
            </div>
            <div
              v-for="(detailItem, index1) in item.reviewList"
              v-show="item.showFlag"
              :id="detailItem.uuid"
              :key="index1"
            >
              <div
                v-for="(reviewItem, index2) in detailItem.attachmentList"
                :key="index2"
              >
                <div class="data-box">
                  <div class="tip-box">
                    {{ detailItem.reviewName }}-不合格项
                  </div>
                  <div class="ai-box">
                    <div class="ai-title">AI建议：</div>
                    <div class="ai-title">
                      文件名：{{ reviewItem.attachmentName }}
                    </div>
                    <div class="ai-title">
                      原因：
                      <p
                        v-for="(resonItem, index3) in reviewItem.reviewItems"
                        :key="index3"
                      >
                        {{ resonItem.reviewItem }} ： {{ resonItem.reason }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="review-opinion">
                  <div>
                    复核意见：
                    <el-radio
                      v-model="reviewItem.type"
                      :disabled="reviewItem.saved"
                      label="1"
                      >采纳</el-radio
                    >
                    <el-radio
                      v-model="reviewItem.type"
                      :disabled="reviewItem.saved"
                      label="2"
                      >不采纳</el-radio
                    >
                  </div>
                  <eui-btn
                    type="primary"
                    font-size="12px"
                    :disabled="reviewItem.saved"
                    @click="saveOpinion(detailItem, index2, item.reviewType)"
                    >保存意见
                  </eui-btn>
                </div>
                <div class="flex-r margin-b20">
                  <el-input
                    v-model="reviewItem.reviewComment"
                    :disabled="reviewItem.saved"
                    class="input-box"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    maxlength="200"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';

export default {
  name: 'AIDataReport',
  props: {
    dataReportVisible: Boolean,
    type: String,
    targetId: Number,
  },
  data() {
    return {
      value: '',
      versionID: '',
      versionData: [],
      reviewList: [],
      listArr: [],
      radio: '1',
      reportData: [],
    };
  },
  mounted() {
    this.scAiCheckOption(); // 查看版本
  },
  methods: {
    saveOpinion(detailItem, index, type) {
      this.scAiCheckReviewAdd(detailItem, index, type);
      // console.log(detailItem, index);
      // let isEdit = false;
      // if (this.reviewList.length > 0) {
      //   this.reviewList.forEach((item) => {
      //     if (
      //       item.fileId.toString() ===
      //         detailItem.attachmentList[index].attachmentId &&
      //       item.reviewAttachmentId.toString() ===
      //         detailItem.reviewId.toString()
      //     ) {
      //       isEdit = true;
      //     }
      //   });
      // }
      // if (isEdit) {
      //   this.scAiCheckReviewModify(detailItem, index, type);
      // } else {
      //   this.scAiCheckReviewAdd(detailItem, index, type);
      // }
    },
    async scAiCheckReviewAdd(detailItem, index, type) {
      const attachmentItem = detailItem.attachmentList[index];
      const params = {
        aiCheckId: this.versionID,
        reviewComment: attachmentItem.reviewComment,
        type: attachmentItem.type,
        reviewType: type && type.includes('一致性') ? '1' : '2', // 1:一致性  ;2:完整性
        reviewAttachmentId: detailItem.reviewId,
        fileId: attachmentItem.attachmentId,
        // attachmentRulesId: reviewItem.reviewRuleId,
      };
      if (params.type === '') {
        this.$message.error('请选择复核意见');
        return;
      }
      const res = await api.scAiCheckReviewAdd(params);
      if (res.code === '200') {
        this.$message.success('感谢意见反馈。');
        this.scAiCheckReviewList();
      }
    },
    async scAiCheckReviewModify(detailItem, index, type) {
      const attachmentItem = detailItem.attachmentList[index];
      const reviewData = this.reviewList.filter(
        (item) => item.fileId.toString() === attachmentItem.attachmentId
      );
      const params = {
        id: reviewData[0].id,
        reviewComment: attachmentItem.reviewComment,
        type: attachmentItem.type,
      };
      const res = await api.scAiCheckReviewModify(params);
      if (res.code === '200') {
        this.$message.success('感谢意见反馈。');
        this.scAiCheckReviewList();
      }
    },

    changeLeftShowFlag(item) {
      item.leftShowFlag = !item.leftShowFlag;
    },
    // 通过id，点击到固定位置
    toPlace(uuid) {
      console.log(uuid);
      // 先获取滚动容器
      const scrollContainer = document.querySelector('.data-right');
      if (!scrollContainer) {
        console.log('未找到滚动容器');
        return;
      }

      // 尝试获取目标元素
      const targetElement = document.querySelector(`#${uuid}`);
      if (targetElement) {
        // 记录目标元素原始颜色
        const originalColor = targetElement.style.color;
        // 设置目标元素颜色为红色
        targetElement.style.color = '#000';

        // 计算目标元素相对于滚动容器顶部的偏移量
        const offsetTop = targetElement.offsetTop - scrollContainer.offsetTop;
        // 设置滚动容器的 scrollTop
        scrollContainer.scrollTop = offsetTop;

        // 1 秒后恢复原始颜色
        setTimeout(() => {
          targetElement.style.color = originalColor;
        }, 1000);
      } else {
        console.log('未找到对应的元素');
        // 处理异步渲染问题，等待下一个渲染周期再尝试
        this.$nextTick(() => {
          const delayedTargetElement = document.querySelector(`#${uuid}`);
          if (delayedTargetElement) {
            const delayedOffsetTop =
              delayedTargetElement.offsetTop - scrollContainer.offsetTop;
            scrollContainer.scrollTop = delayedOffsetTop;
          } else {
            console.log('延迟后仍未找到对应的元素');
          }
        });
      }
    },
    changeShowFlag(index) {
      this.reportData[index].showFlag = !this.reportData[index].showFlag;
    },
    // 1:sku;2:库存单;3:采购意向单成品现货；4：石化商城成品现货  -  type
    // tc_order_sku订单id;epec_ec_stock的id;epec_ec_material_supplier的id  --  targetId
    async scAiCheckOption() {
      const res = await api.scAiCheckOption({
        type: this.type,
        targetId: this.targetId,
      });
      if (res.code === '200') {
        this.versionData = res.data || [];
        this.versionData.forEach((item, index) => {
          const numTime = index + 1;
          item.createTime = `第${numTime}次 (${item.createTime})`;
        });
        this.versionID = this.versionData[this.versionData.length - 1].id;
        this.scAiCheckReviewList();
      }
    },
    // 查询意见
    async scAiCheckReviewList() {
      const res = await api.scAiCheckReviewList({ aiCheckId: this.versionID });
      if (res.code === '200') {
        this.reviewList = res.data;
        this.listArr = this.reviewList.map((item) => item.attachmentRulesId);
        this.scAiCheckReportById();
      }
    },
    handleClose() {
      this.$emit('update:dataReportVisible', false);
    },
    async scAiCheckReportById() {
      const res = await api.scAiCheckReportById({
        type: this.type,
        targetId: this.targetId,
        id: this.versionID,
      });
      if (res.code === '200') {
        const list = JSON.parse(res.data);
        list.forEach((item, i) => {
          const reviewType = item.reviewType.includes('一致性') ? '1' : '2';
          item.reviewList.forEach((reviewItem, j) => {
            const uuid = `uuid-${reviewItem.reviewId}-${i}-${j}`;
            this.$set(reviewItem, 'uuid', uuid);
            reviewItem.attachmentList.forEach((attachmentItem, k) => {
              const obj = this.reviewList.find((o) => {
                return (
                  o.fileId.toString() ===
                    attachmentItem.attachmentId.toString() &&
                  o.reviewAttachmentId.toString() ===
                    reviewItem.reviewId.toString() &&
                  o.reviewType === reviewType
                );
              });
              this.$set(attachmentItem, 'type', obj?.type.toString() || '');
              this.$set(
                attachmentItem,
                'reviewComment',
                obj?.reviewComment || ''
              );
              this.$set(attachmentItem, 'saved', !!obj?.type);
            });
          });
        });
        console.log('获取结果', list);
        this.reportData = list;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.data-wrapper {
  padding: 20px;

  .data-left {
    padding: 16px;
    width: 194px;
    border: 1px solid #d9d9d9;

    .left-title {
      font-size: 14px;
      color: #333;
      font-family: SourceHanSansCN-Medium;
      margin-bottom: 16px;
    }

    .left-little-title {
      font-size: 14px;
      color: #333;
    }

    .left-content {
      font-size: 14px;
      color: #666;
      margin: 4px 0;
      margin-left: 24px;
      cursor: pointer;
    }
  }

  .data-right {
    margin-left: 20px;
    height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    .tip-wrap {
      display: flex;
      background-color: #e8efff;
      padding-left: 10px;
      margin-top: 10px;
      font-size: 14px;
      margin-bottom: 10px;
      height: 44px;
      line-height: 44px;

      .red {
        color: #ef4c56;
        display: inline-block;
        font-family: SourceHanSansCN-bold;
      }
    }

    .version-info {
      height: 40px;
      line-height: 40px;
      background-color: #f5f5f5;
      padding-left: 20px;
      color: #333;
      font-family: SourceHanSansCN-Medium;
      font-size: 14px;
    }

    .review-version {
      margin: 10px 0 10px 42px;
      font-size: 14px;
      color: #333;
    }

    .content-wrapper {
      height: auto;
      border: 1px solid #dcdcdc;
      /*padding-bottom: 20px;*/

      .content-title {
        height: 40px;
        background-color: #f4f7ff;
        line-height: 40px;
        padding: 0 10px;
        color: #2587ff;
        font-size: 14px;
      }

      .data-box {
        padding: 10px;

        .tip-box {
          font-size: 14px;
          font-family: SourceHanSansCN-Medium;
          margin-bottom: 10px;
        }

        .ai-box {
          border: 1px solid #c5c5c5;
          padding: 6px 10px;

          .ai-title {
            color: #333;
            font-size: 14px;
            margin-bottom: 2px;
          }

          .ai-reason {
            font-size: 14px;
            color: #666;
          }
        }
      }

      .review-opinion {
        font-size: 14px;
        padding-right: 10px;
        padding-left: 54px;

        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .input-box {
        width: 444px;
        height: 62px;
        margin-right: 10px;
        margin-top: 10px;
      }
    }
  }
}

::v-deep .el-drawer__header {
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  margin-bottom: 0;
  padding: 16px 20px 0 20px;
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  color: #333;

  span,
  .el-drawer__close-btn {
    margin-bottom: 20px;
    color: #333;
  }
}
</style>
